import { render, staticRenderFns } from "./OpenPosi.vue?vue&type=template&id=3119224c"
import script from "./OpenPosi.vue?vue&type=script&lang=js"
export * from "./OpenPosi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports